















import OlbIcon from '../icon/icon.vue';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	components: { OlbIcon },
	props: {
		url: String,
	},
});
